module.exports = __webpack_public_path__ + "img/gasbot-eyes-opened.8657c210.png";